import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import Icon from "../icon/icon.component"
import { FormattedMessage, injectIntl, } from "react-intl"

const BetaIconWithToolTip = () => {
    return (
        <OverlayTrigger overlay={
            <Tooltip id="tooltip-disabled">
                <FormattedMessage
                    id="common.beta_feature_components.beta_feature_icon.tooltip_text"
                    defaultMessage="This is a beta feature, ask support for more details!"
                />
            </Tooltip >
        }>
            <span className="d-inline-block">
                <Icon value={"flask"} className="mb-1" />
            </span>
        </OverlayTrigger >
    )

}

export default injectIntl(BetaIconWithToolTip)


// WEBPACK FOOTER //
// ./src/common/beta-feature-components/BetaIconWithToolTip.tsx